import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../layouts/Sidebar";
import SidebarResponsive from "../layouts/SidebarResponsive";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import LayoutHeader from "./LayoutHeader";

/* Admin Toast */
import { ToastProvider } from "../../pages/protected/admin/components/AdminSharedComponents";

// Define all required routes
const routes = [
  { path: "/", breadcrumb: null },
  { path: "/admin", breadcrumb: "Adhim" },
  { path: "/admin/dashboard", breadcrumb: "Dashboard" },
  { path: "/admin/projects/add", breadcrumb: "Add Project" },
  { path: "/admin/projects/edit", breadcrumb: null },
  { path: "/admin/projects/edit/:id", breadcrumb: "Edit Project" },
  { path: "/admin/projects/show", breadcrumb: null },
  { path: "/admin/projects/show/:id", breadcrumb: "Project Detail" },
  { path: "/admin/reports/add", breadcrumb: "Add Report" },
  { path: "/admin/reports/show", breadcrumb: "Report Detail" },
  { path: "/admin/reports/show/:id", breadcrumb: null },
  { path: "/admin/reports/edit", breadcrumb: null },
  { path: "/admin/reports/edit/:id", breadcrumb: "Edit Report" },
  { path: "/admin/products/add", breadcrumb: "Add Product" },
  { path: "/admin/products/detail", breadcrumb: null },
  { path: "/admin/products/detail/:id", breadcrumb: "Product Details" },
  { path: "/admin/researchs", breadcrumb: "Research" },
  { path: "/admin/researchs/:id", breadcrumb: null },
  { path: "/admin/researchs/detail/:id", breadcrumb: "Research Details" },
  { path: "/admin/client/add", breadcrumb: "Add Client" },
  { path: "/admin/client/edit/", breadcrumb: "Edit Client" },
  { path: "/admin/client/edit/:id", breadcrumb: null },
  { path: "/admin/users/add", breadcrumb: "Add User" },
  { path: "/admin/users/edit", breadcrumb: "Edit User" },
  { path: "/admin/users/edit/:id", breadcrumb: null },
  { path: "/admin/employees/add", breadcrumb: "Add Employee" },
  { path: "/admin/employees/edit/", breadcrumb: "Edit Employee" },
  { path: "/admin/employees/edit/:id", breadcrumb: null },
];

const AdminLayout = () => {
  const breadcrumbs = useBreadcrumbs(routes);
  const [collapsed, setCollapsed] = useState(false);

  // Filter breadcrumb to remove path "/"
  const filteredBreadcrumbs = breadcrumbs.filter(
    ({ match }) => match.pathname !== "/"
  );

  return (
    <ToastProvider>
      <div className="flex min-h-screen bg-gray-100">
        {/* Sidebar for desktop */}
        <div className="hidden md:block">
          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        </div>

        {/* Responsive sidebar for mobile */}
        <SidebarResponsive />

        {/* Main Content */}
        <main
          className={`w-full transition-all duration-300 ${
            collapsed ? "md:ml-16" : "md:ml-64"
          } mt-16 md:mt-0`}
        >
          {/* Render Child Routes */}
          <LayoutHeader breadcrumbs={filteredBreadcrumbs} />
          <Outlet />
        </main>
      </div>
    </ToastProvider>
  );
};

export default AdminLayout;
